import { createSlice } from "@reduxjs/toolkit";

import { getCourseById } from "./actions";

const initialState = {
  course: null,
};

const investmentsSlice = createSlice({
  name: "courses",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCourseById.fulfilled, (state, action) => {
      state.course = action.payload;
    });
  },
});

export default investmentsSlice.reducer;
